import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';

const useScrollToElement = (offset = 0) => {
  const router = useRouter();
  const elementRef = useRef<HTMLElement>(null);

  useEffect(() => {    
    const handleRouteChange = () => {
      if (elementRef.current) {
        elementRef.current.scrollIntoView({ behavior: "instant" });
      }
    };

    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events, offset]);

  return elementRef;
};

export default useScrollToElement;
